import { useEffect, useState } from "react";

// Shared viewport check used to cut heavy visual effects (large blur
// filters, infinite drift animations) on phones AND tablets, where they're
// the biggest contributor to janky scrolling. Threshold matches Tailwind's
// `lg` (1024px) so tablets get the lighter treatment too, not just phones.
export function useIsMobile(breakpoint = 1024) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return isMobile;
}
